import { find, findIndex } from "lodash";
import moment from "moment";

import Utils, {
  BASE_GROUPS,
  decToHHmm,
  getWeekInterval,
  formatDateByTimeUnit,
  hasItems,
  sortBy,
} from "../../../helpers/utils";
import TutorialsHelper from "../tutorials/TutorialsHelper";
import formats from "./header/formats";

import FORMATS from "./header/formats";
import ViewModes from "./header/viewModes";
const DATE_FORMAT = "YYYY-MM-DD";

const addCoreElementsHours = (reflections) => {
  const model = {
    core_elements: {},
    days: [],
  };

  BASE_GROUPS.forEach((setName) => {
    const setReflection = find(reflections, (r) => setName == r.name);

    if (setReflection && setReflection?.timeline?.hours) {
      model.days = setReflection.timeline.days;
      model.core_elements[setName.toLowerCase()] = setReflection.timeline;
    }
  });

  return model;
};

const getReflectionSelectedDate = ({
  viewMode,
  showTutorials,
  userSelectedDate,
  timeUnit
}) => {
  if (showTutorials) {
    userSelectedDate = TutorialsHelper.getLastWeekDate();
  }

  const selectedDate = userSelectedDate
    ? moment(userSelectedDate)
    : Utils.nowUserTz(this.controller);

  if (viewMode == ViewModes.tableView) return selectedDate;

  const now = moment();
  const today = now.format(DATE_FORMAT);
  const wednesday = moment().isoWeekday(3).set("hour", 4).set("minutes", 0);

  if (
    timeUnit == "week" &&
    today == selectedDate.format(DATE_FORMAT) &&
    (viewMode == ViewModes.insights || // insights always show prev week
      (!userSelectedDate && selectedDate <= wednesday))
  ) {
    selectedDate.add(-1, "week").endOf("isoweek");
  }

  return selectedDate;
};

const getPeriodDisplayText = (selectedDate, timeUnit = "week") => {
  const format = FORMATS[timeUnit].reportFormat;

  return timeUnit === "week"
    ? "Week of " + getWeekInterval(selectedDate, format)
    : formatDateByTimeUnit({
        date: selectedDate,
        timeUnit,
        format,
        prefix:
          timeUnit == "quarter"
            ? "ending"
            : ["month", "year"].includes(timeUnit)
            ? "of"
            : "",
      });
};

const getReflectionHeaderPeriod = (selectedDate, tu) => {
  const format = formats[tu]?.displayFormat;

  if (tu === "week") {
    return getWeekInterval(selectedDate, format);
  } else {
    const currentQ = moment().format(FORMATS.quarter.format);

    return formatDateByTimeUnit({
      date: selectedDate,
      timeUnit: tu,
      format,
      currentInterval: tu == "quarter" ? currentQ : null,
    });
  }
};

const getReflectionAverageHours = (reflectionHours, selectedDate) => {
  const allDays = sortBy(Object.keys(reflectionHours));
  let currentDayIndex = findIndex(allDays, (d) => d == selectedDate);
  if (currentDayIndex <= 0) return 0;

  const start = Math.max(0, currentDayIndex - 10);
  const end = Math.min(start + 10, currentDayIndex + 1);

  const hours = Object.values(reflectionHours).map((r) => r.hours);

  const last10Entries = hours.slice(start, end);
  const total = last10Entries.reduce((acc, c) => acc + c, 0);

  return total / last10Entries.length;
};

// Reflection sentence
const getOperatorText = (diff) => {
  return diff < 0
    ? decToHHmm(diff) + " less than"
    : diff > 0
    ? decToHHmm(diff) + " more than"
    : "the same amount of time as";
};

const getElementGems = (
  controller,
  { reflectionDate, time_unit },
  cb = () => {},
) => {
  let gems = {};
  controller.getApiData(
    "reflection",
    {
      reflectionDate,
      time_unit,
    },
    (response) => {
      _mapGemsToElementIds(gems, response.children) || {};
      cb(gems);
    },
  );

  return gems;
};

const _mapGemsToElementIds = (gems, children) => {
  if (!hasItems(children)) return;

  children.forEach((c) => {
    _mapGemsToElementIds(gems, c.children);

    if (hasItems(c.days) && c.days[0].gem) {
      gems[c.item_id] = c.days[0].gem;
    }
  });
};

const ReflectionHelper = {
  addCoreElementsHours,
  getReflectionSelectedDate,
  getPeriodDisplayText,
  getReflectionAverageHours,
  getOperatorText,
  getElementGems,
  getReflectionHeaderPeriod,
};

export default ReflectionHelper;
